import React, {Fragment, useMemo} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Alert} from "antd";
import {GUTTER_MD} from "../../../../../styles/constants";

const mapStateToProps = state => {
    return {
        selectedTables: state.scenes.mappingHandler.datasetBuilder.unionModalProps.selectedTables,
    }
};

const UnionAlert = ({t, selectedTables, forceFromExternalCondition = null, style, customMessage}) => {
    const areUnionSizesMismatched = useMemo(() => {
        if (forceFromExternalCondition !== null) return forceFromExternalCondition;
        if (selectedTables.length <= 1) return false;
        const allLengths = [...new Set(selectedTables.map(table => table.aliasCols.length))];
        return allLengths.length > 1;
    }, [selectedTables, forceFromExternalCondition]);

    return (
        <Fragment>
            {!!areUnionSizesMismatched && <Alert
                style={{marginBottom: GUTTER_MD, ...style}}
                message={customMessage ? customMessage : t("data.datasetBuilder.mismatchUnionWarning")}
                type="warning"
                showIcon
            />}
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps),
)(UnionAlert);